<template>
    <span style="cursor: pointer;"
          @click="openScenario()"
          :class="`${lineThroughClass}--text`">
        {{scenarioText}}
        <v-icon :color="lineThroughClass" v-if="scenario.is_complete">mdi-flag-checkered</v-icon>
    </span>
</template>

<script>
export default {
  props: {
    scenario: {
      id: Number,
      number: Number,
      title: String,
      select_text: String,
      required: String,
      is_complete: Boolean,
      is_accessible: Boolean,
      achievements: [
        {
          id: Number,
          title: String,
          type: String
        }
      ]
    },
    scenarioIndex: Number,
    party: {
      id: Number
    }
  },

  computed: {
    scenarioText: function () {
      return this.scenario.select_text + " - " + this.scenario.required;
    },

    lineThroughClass: function () {
      if (this.scenario.is_accessible)
        return 'green'

      return 'red'
    }
  },

  methods: {
    openScenario() {
      this.$router.push({name: 'scenario', params: {scenarioId: this.scenario.id, partyId: this.party.id}});
    }
  }
};
</script>

<style scoped>
.line-through {
    text-decoration-line: line-through;
}
</style>